(function () {
  const walls = document.querySelectorAll('[data-video-wall]');
  if (!walls.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pointerFine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const mobileLayout = window.matchMedia('(max-width: 640px)');

  walls.forEach(initWall);

  function initWall(root) {
    const dataEl = root.querySelector('[data-video-wall-data]');
    const grid = root.querySelector('[data-video-wall-grid]');
    const status = root.querySelector('[data-video-wall-status]');
    const search = root.querySelector('[data-video-wall-search]');
    const filterGroups = root.querySelector('[data-video-wall-filter-groups]');
    const sentinel = root.querySelector('[data-video-wall-sentinel]');
    const modal = root.querySelector('[data-video-wall-modal]');
    const modalMedia = root.querySelector('[data-video-wall-modal-media]');
    const modalStage = root.querySelector('[data-video-wall-stage]');
    const bugEl = root.querySelector('[data-video-wall-bug]');
    const navWrap = root.querySelector('[data-video-wall-nav]');
    const prevButton = root.querySelector('[data-video-wall-prev]');
    const nextButton = root.querySelector('[data-video-wall-next]');
    const closeButton = root.querySelector('[data-video-wall-close]');
    const soundButton = root.querySelector('[data-video-wall-sound]');
    const searchToggle = root.querySelector('[data-video-wall-search-toggle]');
    const searchPanel = root.querySelector('[data-video-wall-search-panel]');
    const shareButton = root.querySelector('[data-video-wall-share]');
    const shareLabel = root.querySelector('[data-video-wall-share-label]');
    const initialCount = Number(root.dataset.initialCount || 24);
    const autoplayOnLoad = root.dataset.autoplay === 'true';
    const defaultWall = root.dataset.defaultWall || '';
    const isHighlights = root.dataset.videoWallMode === 'highlights';

    let tiles = safeJson(dataEl ? dataEl.textContent : '[]', []);
    tiles = tiles.map(normalizeTile).filter(Boolean).sort(sortTiles);

    let state = getState(defaultWall);
    let renderedCount = 0;
    let visibleTiles = [];
    let expandedTileButton = null;
    let lastFocused = null;
    let currentTile = null;
    let activeVideoHandle = '';
    let shareResetTimer = null;
    let tuneDismissTimer = null;
    let bugTimer = null;
    const BUG_DELAY_MS = 5500;
    let playerHome = null;
    const hoverPreviewTimers = new WeakMap();

    function mountPlayerToBody() {
      if (!modal || modal.dataset.bwwBodyMount === '1') return;
      playerHome = document.createComment('bww-video-player-home');
      modal.parentNode.insertBefore(playerHome, modal);
      document.body.appendChild(modal);
      modal.dataset.bwwBodyMount = '1';
    }

    function restorePlayerToSection() {
      if (!modal || modal.dataset.bwwBodyMount !== '1' || !playerHome || !playerHome.parentNode) return;
      playerHome.parentNode.insertBefore(modal, playerHome);
      playerHome.remove();
      playerHome = null;
      delete modal.dataset.bwwBodyMount;
    }

    function stopModalPlayback() {
      if (!modalMedia) return;
      modalMedia.querySelectorAll('video').forEach((video) => {
        try { video.pause(); } catch (e) { /* ignore */ }
      });
      modalMedia.querySelectorAll('iframe').forEach((iframe) => {
        const src = iframe.src || '';
        try {
          if (src.includes('youtube.com') || src.includes('youtu.be')) {
            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          } else if (src.includes('vimeo.com')) {
            iframe.contentWindow.postMessage('{"method":"pause"}', '*');
          }
        } catch (e) { /* ignore */ }
        iframe.src = 'about:blank';
      });
    }

    function ensureMiniPlayerVisible() {
      if (!modal) return;
      if (typeof modal.bwwRestorePos === 'function') {
        try { modal.bwwRestorePos(); } catch (e) { /* ignore */ }
        return;
      }
      if (typeof modal.bwwAnchorFromLayout === 'function') {
        try { modal.bwwAnchorFromLayout(); } catch (e) { /* ignore */ }
      }
    }

    const videoObserver = createVideoObserver();
    const loadObserver = createLoadObserver();

    root.style.setProperty('--video-wall-focus', firstAccent(tiles));
    if (!isHighlights) {
      window.setTimeout(() => {
        root.classList.add('is-tuned-in');
      }, 2600);
    }

    if (isHighlights) {
      tiles = tiles.filter((tile) => tile.wall.includes('archive')).slice(0, 6);
      visibleTiles = tiles.slice();
      renderHighlightCards();
      bindEvents();
      wireHighlightPromo();
    } else {
      buildFilters();
      applyFilters();
      bindEvents();
      openFromDeepLink();
    }

    function bindEvents() {
      if (search) {
        search.value = state.q || '';
        search.addEventListener('input', debounce(() => {
          state.q = search.value.trim();
          updateUrl();
          applyFilters();
        }, 160));
      }

      if (searchToggle && searchPanel) {
        searchToggle.addEventListener('click', () => {
          const expanded = searchPanel.classList.toggle('is-open');
          searchToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          searchPanel.hidden = !expanded;
          if (expanded && search) {
            window.setTimeout(() => search.focus(), 120);
          }
        });
      }

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && searchPanel && searchPanel.classList.contains('is-open')) {
          searchPanel.classList.remove('is-open');
          searchPanel.hidden = true;
          if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
        }
      });

      const introWrap = root.querySelector('[data-video-wall-intro]');
      const introToggle = root.querySelector('[data-video-wall-intro-toggle]');
      const introLabel = root.querySelector('[data-video-wall-intro-label]');
      if (introWrap && introToggle && introLabel) {
        introToggle.addEventListener('click', () => {
          const expanded = introWrap.classList.toggle('is-expanded');
          introToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          introLabel.textContent = expanded ? 'Show less' : 'Read more';
        });
      }

      if (shareButton) {
        shareButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          handleShare();
        });
      }

      if (soundButton) {
        soundButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const video = getModalVideo();
          if (!video) return;
          video.muted = !video.muted;
          if (!video.muted) video.removeAttribute('muted');
          else video.setAttribute('muted', '');
          syncSoundButton();
          if (!video.muted) video.play().catch(() => {});
        });
      }

      if (prevButton) {
        prevButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          goToPrevTile();
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          goToNextTile();
        });
      }

      document.addEventListener('keydown', onModalKeydown);

      window.addEventListener('resize', () => {
        if (!modal || !modal.open) return;
        positionBugOverVideo();
        const video = getModalVideo();
        if (video) video.controls = !mobileLayout.matches;
        syncSoundButton();
      });

      if (modal) {
        modal.addEventListener('cancel', (event) => {
          event.preventDefault();
          if (modal.classList.contains('is-mini')) {
            closeModal();
          } else {
            minimiseModal();
          }
        });
        modal.addEventListener('keydown', trapFocus);
      }

      ['pointerdown', 'click', 'dblclick', 'touchstart'].forEach((eventName) => {
        document.addEventListener(eventName, handleModalDismissEvent, {
          capture: true,
          passive: false
        });
      });
    }

    function handleModalDismissEvent(event) {
      if (!modal || !modal.open) return;

      const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
      const closeHit = path.find((node) => node && node.getAttribute && node.getAttribute('data-video-wall-close') !== null);
      const soundHit = path.find((node) => node && node.getAttribute && node.getAttribute('data-video-wall-sound') !== null);
      if (soundHit) return;
      const isMini = modal.classList.contains('is-mini');

      if (closeHit) {
        event.preventDefault();
        event.stopPropagation();
        if (isMini) {
          closeModal();
        } else {
          minimiseModal();
        }
        return;
      }

      // Mini player: drag to move; double-click to expand (single click must not close or clear media).
      if (isMini) {
        if (modal.dataset.bwwJustDragged === '1') {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        if (event.type === 'dblclick') {
          const shell = modal.querySelector('.video-wall__modal-shell');
          const tappedShell = shell && (path.includes(shell) || shell.contains(event.target));
          if (tappedShell) {
            event.preventDefault();
            event.stopPropagation();
            expandModal();
          }
        }
        return;
      }

      if (event.type === 'touchstart') return;

      const shell = modal.querySelector('.video-wall__modal-shell');
      if (!shell) return;
      const clickedInside = path.includes(shell) || shell.contains(event.target);
      if (!clickedInside) {
        event.preventDefault();
        event.stopPropagation();
        minimiseModal();
      }
    }

    function buildFilters() {
      if (!filterGroups) return;
      filterGroups.textContent = '';

      const groups = [
        { key: 'wall', label: 'Collection', values: uniqueValues(tiles, 'wall') },
        { key: 'year', label: 'Year', values: uniqueValues(tiles, 'year') },
        { key: 'type', label: 'Format', values: uniqueValues(tiles, 'eventType') }
      ].filter((group) => group.values.length);

      groups.forEach((group) => {
        const wrapper = document.createElement('div');
        wrapper.className = 'video-wall__filter-group';

        const label = document.createElement('span');
        label.className = 'video-wall__filter-label';
        label.textContent = group.label;
        wrapper.appendChild(label);

        wrapper.appendChild(createFilterButton(group.key, '', 'All'));
        group.values.forEach((value) => wrapper.appendChild(createFilterButton(group.key, value, formatFilterLabel(value, group.key))));
        filterGroups.appendChild(wrapper);
      });
    }

    function createFilterButton(key, value, label) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'video-wall__chip';
      button.dataset.filterKey = key;
      button.dataset.filterValue = value;
      button.textContent = label;
      button.addEventListener('click', () => {
        state[key] = value;
        updateUrl();
        applyFilters();
      });
      return button;
    }

    function applyFilters() {
      visibleTiles = tiles.filter(matchesState);
      renderedCount = 0;
      grid.textContent = '';
      renderMore();
      updateFilterButtons();
      updateStatus();
      if (loadObserver && sentinel) loadObserver.observe(sentinel);
    }

    function renderMore() {
      const next = visibleTiles.slice(renderedCount, renderedCount + initialCount);
      next.forEach((tile) => grid.appendChild(createTile(tile)));
      renderedCount += next.length;

      if (!visibleTiles.length) {
        const empty = document.createElement('div');
        empty.className = 'video-wall__empty';
        empty.textContent = tiles.length ? 'No videos match those filters yet.' : 'No video wall tiles are available yet.';
        grid.appendChild(empty);
      }
    }

    function highlightThumbnailUrl(tile) {
      if (tile.poster.url) return tile.poster.url;
      if (tile.heroImage.url) return tile.heroImage.url;
      return getVideoThumbnail(tile);
    }

    function renderHighlightCards() {
      if (!grid) return;
      grid.textContent = '';
      visibleTiles.forEach((tile) => {
        const card = document.createElement('button');
        card.type = 'button';
        card.className = 'video-highlights__card';
        card.setAttribute('aria-label', tile.title ? `Watch ${tile.title}` : 'Watch video');

        const thumb = highlightThumbnailUrl(tile);
        const source = String(tile.videoSource || '').toLowerCase();
        const youtubeId = source === 'youtube'
          ? tile.videoId || extractVideoId(tile.videoUrl, 'youtube')
          : '';

        card.innerHTML = `
          <div class="video-highlights__media">
            ${thumb
              ? `<img class="video-highlights__img" src="${escapeAttr(thumb)}" alt="${escapeAttr(tile.poster.alt || tile.title || 'Belfast Whiskey Week video')}" loading="lazy" width="1000" height="563"${youtubeId ? ` data-youtube-id="${escapeAttr(youtubeId)}"` : ''}>`
              : '<div class="video-highlights__placeholder" aria-hidden="true"></div>'}
            <span class="video-highlights__play" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="currentColor" focusable="false"><path d="M8 5v14l11-7z"/></svg>
            </span>
          </div>
          <div class="video-highlights__body">
            ${tile.title ? `<h3 class="video-highlights__title">${escapeHtml(tile.title)}</h3>` : ''}
          </div>
        `;
        card.addEventListener('click', () => openModal(tile, card));
        grid.appendChild(card);
      });
      bindHighlightThumbnailFallbacks();
    }

    function bindHighlightThumbnailFallbacks() {
      root.querySelectorAll('.video-highlights__img[data-youtube-id]').forEach((img) => {
        const id = img.dataset.youtubeId;
        if (!id) return;
        const qualities = ['sddefault', 'mqdefault'];
        let index = 0;
        img.addEventListener('error', () => {
          const quality = qualities[index];
          index += 1;
          if (quality) img.src = `https://i.ytimg.com/vi/${encodeURIComponent(id)}/${quality}.jpg`;
        });
      });
    }

    function wireHighlightPromo() {
      const promoClose = root.querySelector('[data-video-highlights-promo-close]');
      const promo = root.querySelector('[data-video-highlights-promo]');
      if (!promoClose || !promo) return;
      promoClose.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        promo.hidden = true;
      });
    }

    function createTile(tile) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'video-wall__tile';
      button.dataset.tileId = tile.id;
      button.dataset.ratio = tile.aspectRatio;
      button.style.setProperty('--tile-accent', tile.accentColor);
      button.setAttribute('aria-label', `Watch ${tile.title}`);
      if (tile.featured) button.classList.add('is-featured');

      const media = document.createElement('span');
      media.className = 'video-wall__tile-media';
      const imageUrl = tile.poster.url || tile.squareImage.url || tile.heroImage.url || getVideoThumbnail(tile);
      if (!imageUrl && !tile.loopVideoUrl) button.classList.add('video-wall__tile--no-media');
      if (imageUrl) {
        button.classList.add('is-loading');
        const img = document.createElement('img');
        img.className = 'video-wall__tile-poster';
        img.src = imageUrl;
        img.alt = tile.poster.alt || tile.squareImage.alt || tile.heroImage.alt || '';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.addEventListener('load', () => button.classList.remove('is-loading'), { once: true });
        img.addEventListener('error', () => button.classList.remove('is-loading'), { once: true });
        if (tile.videoSource === 'youtube' && !tile.poster.url && !tile.squareImage.url && !tile.heroImage.url) {
          bindYouTubeThumbnailFallback(img, tile, button);
        }
        media.appendChild(img);
      }

      if (tile.loopVideoUrl && isDirectVideoFile(tile.loopVideoUrl) && !prefersReducedMotion && !mobileLayout.matches) {
        const video = document.createElement('video');
        video.className = 'video-wall__tile-video';
        video.muted = true;
        video.defaultMuted = true;
        video.autoplay = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'auto';
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
        video.setAttribute('aria-label', `${tile.title} preview`);
        if (imageUrl) video.poster = imageUrl;
        const source = document.createElement('source');
        source.src = tile.loopVideoUrl;
        source.type = videoMimeFromUrl(tile.loopVideoUrl);
        video.appendChild(source);
        video.addEventListener('loadeddata', () => {
          video.classList.add('is-ready');
          video.play().catch(() => {});
        }, { once: true });
        video.addEventListener('error', () => {
          video.remove();
          if (!imageUrl) button.classList.add('video-wall__tile--no-media');
        }, { once: true });
        media.appendChild(video);
        if (videoObserver) videoObserver.observe(video);
      }

      const overlay = document.createElement('span');
      overlay.className = 'video-wall__tile-overlay';
      const durationLabel = formatDuration(tile.durationSeconds);
      overlay.innerHTML = `
        ${durationLabel ? `<span class="video-wall__tile-duration">${escapeHtml(durationLabel)}</span>` : ''}
        <span class="video-wall__tile-play" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 5.5v13l11-6.5-11-6.5Z" fill="currentColor"/>
          </svg>
        </span>
        <span class="video-wall__tile-meta">
          ${tile.year ? `<span class="video-wall__tile-pill">${escapeHtml(tile.year)}</span>` : ''}
          ${tile.eventType ? `<span class="video-wall__tile-pill">${escapeHtml(tile.eventType)}</span>` : ''}
        </span>
        <span class="video-wall__tile-title">${escapeHtml(tile.title)}</span>
        ${tile.summary ? `<span class="video-wall__tile-summary">${escapeHtml(tile.summary)}</span>` : ''}
      `;

      button.append(media, overlay);
      button.addEventListener('click', () => handleTileClick(tile, button));
      button.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openModal(tile, button);
        }
      });
      if (tile.loopVideoUrl && isDirectVideoFile(tile.loopVideoUrl) && !prefersReducedMotion && !mobileLayout.matches) {
        button.addEventListener('mouseenter', () => playPreviewBurst(button));
        button.addEventListener('mouseleave', () => stopPreviewBurst(button, true));
        button.addEventListener('focus', () => playPreviewBurst(button));
        button.addEventListener('blur', () => stopPreviewBurst(button, true));
        if (!pointerFine) {
          button.addEventListener('touchstart', () => playPreviewBurst(button), { passive: true });
          button.addEventListener('touchend', () => stopPreviewBurst(button, true), { passive: true });
          button.addEventListener('touchcancel', () => stopPreviewBurst(button, true), { passive: true });
        }
      }

      return button;
    }

    function playPreviewBurst(button) {
      const video = button.querySelector('.video-wall__tile-video');
      if (!video) return;
      window.clearTimeout(hoverPreviewTimers.get(video));
      if (video.paused) {
        try {
          video.currentTime = 0;
        } catch (error) {}
      }
      video.muted = true;
      video.play().catch(() => {});
      hoverPreviewTimers.set(video, window.setTimeout(() => stopPreviewBurst(button, false), 4500));
    }

    function stopPreviewBurst(button, reset) {
      const video = button.querySelector('.video-wall__tile-video');
      if (!video) return;
      window.clearTimeout(hoverPreviewTimers.get(video));
      hoverPreviewTimers.delete(video);
      if (!video.paused) video.pause();
      if (reset) {
        try {
          video.currentTime = 0;
        } catch (error) {}
      }
    }

    function handleTileClick(tile, button) {
      openModal(tile, button);
    }

    function mediaMountTarget() {
      return modalStage || modalMedia;
    }

    function getCurrentIndex() {
      if (!currentTile) return -1;
      const handle = currentTile.handle || currentTile.id || '';
      return visibleTiles.findIndex((t) => (t.handle || t.id) === handle);
    }

    function updateModalNav() {
      const multi = visibleTiles.length > 1;
      const mini = modal && modal.classList.contains('is-mini');
      if (navWrap) navWrap.hidden = !multi || mini;
      const idx = getCurrentIndex();
      if (!multi || idx < 0) return;
      const total = visibleTiles.length;
      const pos = idx + 1;
      const prevPos = ((idx - 1 + total) % total) + 1;
      const nextPos = ((idx + 1) % total) + 1;
      if (prevButton) prevButton.setAttribute('aria-label', `Previous video (${prevPos} of ${total})`);
      if (nextButton) nextButton.setAttribute('aria-label', `Next video (${nextPos} of ${total})`);
      if (navWrap) navWrap.setAttribute('aria-label', `Video ${pos} of ${total}`);
    }

    function hideBug() {
      if (bugTimer) {
        window.clearTimeout(bugTimer);
        bugTimer = null;
      }
      if (bugEl) bugEl.classList.remove('is-visible');
    }

    function positionBugOverVideo() {
      if (!bugEl || !modalStage) return;
      const target = modalStage.querySelector('video, iframe');
      if (!target) {
        bugEl.style.removeProperty('left');
        bugEl.style.removeProperty('bottom');
        return;
      }
      const stageRect = modalStage.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();
      if (!stageRect.width || !targetRect.width) return;
      const pad = 10;
      const left = Math.max(pad, targetRect.left - stageRect.left + pad);
      const bottom = Math.max(pad, stageRect.bottom - targetRect.bottom + pad);
      bugEl.style.left = `${Math.round(left)}px`;
      bugEl.style.bottom = `${Math.round(bottom)}px`;
    }

    function scheduleBug() {
      hideBug();
      if (!bugEl) return;
      const show = () => {
        bugTimer = null;
        if (modal && modal.open) {
          bugEl.classList.add('is-visible');
          positionBugOverVideo();
        }
      };
      const delay = prefersReducedMotion ? 0 : BUG_DELAY_MS;
      bugTimer = window.setTimeout(show, delay);
    }

    function bindBugOnPlayback() {
      const mount = mediaMountTarget();
      const video = mount && mount.querySelector('video');
      if (!video) {
        scheduleBug();
        return;
      }
      video.addEventListener('playing', () => {
        scheduleBug();
        positionBugOverVideo();
      }, { once: true });
      video.addEventListener('loadedmetadata', positionBugOverVideo);
      video.addEventListener('loadeddata', positionBugOverVideo);
    }

    function clearModalStage() {
      hideBug();
      if (bugEl) {
        bugEl.style.removeProperty('left');
        bugEl.style.removeProperty('bottom');
      }
      if (modalStage) {
        Array.from(modalStage.children).forEach((node) => {
          if (node !== bugEl) node.remove();
        });
        return;
      }
      if (modalMedia) modalMedia.textContent = '';
    }

    function onModalKeydown(event) {
      if (!modal || !modal.open) return;
      if (modal.classList.contains('is-mini')) return;
      if (visibleTiles.length < 2) return;
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goToNextTile();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goToPrevTile();
      }
    }

    function loadModalTile(tile, options = {}) {
      currentTile = tile;
      activeVideoHandle = tile.handle || tile.id || '';
      if (!isHighlights) updateUrl();
      resetShareLabel();
      if (shareButton) shareButton.hidden = !tile.handle;

      const kickerEl = root.querySelector('[data-video-wall-modal-kicker]');
      const titleEl = root.querySelector('[data-video-wall-modal-title]');
      const subtitleEl = root.querySelector('[data-video-wall-modal-subtitle]');
      const copyEl = root.querySelector('[data-video-wall-modal-copy]');
      if (kickerEl) kickerEl.textContent = [tile.year, tile.eventType].filter(Boolean).join(' / ');
      if (titleEl) titleEl.textContent = tile.title;
      if (subtitleEl) subtitleEl.textContent = tile.subtitle || '';
      if (copyEl) {
        copyEl.innerHTML = tile.bodyHtml || (tile.summary ? `<p>${escapeHtml(tile.summary)}</p>` : '');
      }
      if (modal) {
        modal.style.setProperty('--modal-accent', tile.accentColor);
        modal.setAttribute('aria-label', tile.title);
      }

      renderModalMedia(tile, options);
      if (!isHighlights) {
        renderCreator(tile);
        renderChips(tile);
        renderTranscript(tile);
        renderNext(tile);
      }
      renderCta(tile);
      updateModalNav();
      window.requestAnimationFrame(() => {
        positionBugOverVideo();
        window.requestAnimationFrame(positionBugOverVideo);
      });
    }

    function goToNextTile() {
      const idx = getCurrentIndex();
      if (idx < 0 || visibleTiles.length < 2) return;
      loadModalTile(visibleTiles[(idx + 1) % visibleTiles.length], { unmuted: true });
    }

    function goToPrevTile() {
      const idx = getCurrentIndex();
      if (idx < 0 || visibleTiles.length < 2) return;
      loadModalTile(visibleTiles[(idx - 1 + visibleTiles.length) % visibleTiles.length], { unmuted: true });
    }

    function openModal(tile, trigger) {
      if (!modal) return;
      if (modal.open) {
        loadModalTile(tile);
        return;
      }
      // iOS Safari positions <dialog> using document scroll position; stash and zero it so the modal sits in the viewport.
      const scrollY = window.scrollY || window.pageYOffset || 0;
      if (scrollY > 0 && !document.body.dataset.videoWallScrollY) {
        document.body.dataset.videoWallScrollY = String(scrollY);
        try { window.scrollTo(0, 0); } catch (e) { /* ignore */ }
      }
      lastFocused = trigger || document.activeElement;
      expandedTileButton = null;
      grid.classList.remove('is-touch-active');
      grid.querySelectorAll('.is-expanded').forEach((el) => el.classList.remove('is-expanded'));

      loadModalTile(tile);
      mountPlayerToBody();
      modal.classList.remove('is-mini');

      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
      document.documentElement.classList.add('video-wall-modal-open');
      // Make sure the modal and its inner scrollable regions open from the top.
      try {
        modal.scrollTop = 0;
        const shellEl = modal.querySelector('.video-wall__modal-shell');
        const bodyEl = modal.querySelector('.video-wall__modal-body');
        if (shellEl) shellEl.scrollTop = 0;
        if (bodyEl) bodyEl.scrollTop = 0;
      } catch (e) { /* ignore */ }
      setupModalPinObserver();
      if (closeButton && typeof closeButton.focus === 'function') {
        closeButton.focus({ preventScroll: true });
      }
    }

    function closeModal() {
      if (!modal) return;
      if (soundButton) soundButton.hidden = true;
      hideBug();
      clearTuneDismiss();
      removeModalTune();
      modal.classList.remove('is-mini');
      // Drop the ?v= deep link so a closed player isn't reflected in a shareable/back-forward URL.
      currentTile = null;
      activeVideoHandle = '';
      if (!isHighlights) updateUrl();
      resetShareLabel();
      // Restore the document scroll position we stashed in openModal.
      try {
        const stored = document.body.dataset.videoWallScrollY;
        if (stored) {
          const storedScroll = parseInt(stored, 10) || 0;
          delete document.body.dataset.videoWallScrollY;
          window.scrollTo(0, storedScroll);
        }
      } catch (e) { /* ignore */ }
      try { teardownModalPinObserver(); } catch (e) { console.warn('[video-wall] teardown failed', e); }
      try {
        stopModalPlayback();
        clearModalStage();
      } catch (e) { console.warn('[video-wall] clear media failed', e); }
      restorePlayerToSection();
      ['left', 'top', 'right', 'bottom', 'inset'].forEach((prop) => modal.style.removeProperty(prop));
      delete modal.dataset.bwwDragged;
      try {
        if (typeof modal.close === 'function' && modal.open) {
          modal.close();
        } else {
          modal.removeAttribute('open');
        }
      } catch (e) {
        console.warn('[video-wall] modal.close() failed', e);
        modal.removeAttribute('open');
        modal.style.display = 'none';
        window.setTimeout(() => { modal.style.display = ''; }, 0);
      }
      try {
        if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus({ preventScroll: true });
      } catch (e) { /* ignore */ }
      document.documentElement.classList.remove('video-wall-modal-open');
      document.body.style.overflow = '';
    }

    function minimiseModal() {
      const isOpen = modal && (modal.open || modal.hasAttribute('open'));
      if (!isOpen) return;
      if (modal.classList.contains('is-mini')) return;
      clearTuneDismiss();
      removeModalTune();
      try { teardownModalPinObserver(); } catch (e) {}
      // Restore the page's original scroll so the user lands back where they were while the mini player floats.
      try {
        const stored = document.body.dataset.videoWallScrollY;
        if (stored) {
          const storedScroll = parseInt(stored, 10) || 0;
          delete document.body.dataset.videoWallScrollY;
          window.scrollTo(0, storedScroll);
        }
      } catch (e) { /* ignore */ }
      mountPlayerToBody();
      // Leave the top layer: a modal <dialog> (showModal) paints above ALL fixed UI
      // regardless of z-index and makes the page inert. Re-show non-modally so the mini
      // player behaves like the other floating widgets — the page stays interactive and
      // the switcher/countdown keep their z-index and stay grabbable above it.
      try {
        if (modal.open && typeof modal.close === 'function') modal.close();
        if (typeof modal.show === 'function') modal.show();
        else modal.setAttribute('open', '');
      } catch (e) { try { modal.setAttribute('open', ''); } catch (err) { /* ignore */ } }
      modal.classList.add('is-mini');
      updateModalNav();
      document.documentElement.classList.remove('video-wall-modal-open');
      document.body.style.overflow = '';
      window.requestAnimationFrame(() => {
        initMiniPlayerDrag(modal);
        window.requestAnimationFrame(() => {
          ensureMiniPlayerVisible();
          nudgeModalPlayback();
        });
      });
    }

    function initMiniPlayerDrag(dialog) {
      if (!dialog || typeof window.bwwMakeDraggable !== 'function') return;
      try {
        window.bwwMakeDraggable(dialog, {
          storageKey: 'bww:mini-player-pos',
          minWidthQuery: '(min-width: 0px)'
        });
      } catch (e) { /* ignore */ }
    }

    function expandModal() {
      const isOpen = modal && (modal.open || modal.hasAttribute('open'));
      if (!isOpen) return;
      if (!modal.classList.contains('is-mini')) return;
      clearTuneDismiss();
      removeModalTune();
      // Stash scroll and zero so the full-screen modal sits in the viewport on iOS.
      const scrollY = window.scrollY || window.pageYOffset || 0;
      if (scrollY > 0 && !document.body.dataset.videoWallScrollY) {
        document.body.dataset.videoWallScrollY = String(scrollY);
        try { window.scrollTo(0, 0); } catch (e) { /* ignore */ }
      }
      ['left', 'top', 'right', 'bottom', 'inset'].forEach((prop) => modal.style.removeProperty(prop));
      delete modal.dataset.bwwDragged;
      modal.classList.remove('is-mini');
      // Return to a true modal (backdrop + top layer) for the full-screen view. The
      // minimized player is a non-modal open dialog, so close it first then re-open modally.
      try { if (modal.open && typeof modal.close === 'function') modal.close(); } catch (e) { /* ignore */ }
      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
      document.documentElement.classList.add('video-wall-modal-open');
      try {
        modal.scrollTop = 0;
        const shellEl = modal.querySelector('.video-wall__modal-shell');
        const bodyEl = modal.querySelector('.video-wall__modal-body');
        if (shellEl) shellEl.scrollTop = 0;
        if (bodyEl) bodyEl.scrollTop = 0;
      } catch (e) { /* ignore */ }
      setupModalPinObserver();
      updateModalNav();
      window.requestAnimationFrame(() => nudgeModalPlayback());
    }

    let modalScrollHandler = null;
    let modalScrollTarget = null;

    function setupModalPinObserver() {
      const shell = modal.querySelector('.video-wall__modal-shell');
      const mediaEl = modal.querySelector('.video-wall__modal-media');
      if (!shell || !mediaEl || mobileLayout.matches) return;
      teardownModalPinObserver();
      shell.classList.remove('is-pinned');
      shell.style.setProperty('--modal-scroll-progress', '0');
      shell.style.setProperty('--modal-media-inset', '12px');
      shell.style.setProperty('--modal-media-top', '12px');
      shell.style.setProperty('--modal-media-radius', '18px');
      modalScrollTarget = shell;
      const threshold = () => Math.max(90, mediaEl.offsetHeight * 0.5);
      modalScrollHandler = () => {
        const limit = threshold();
        const progress = Math.max(0, Math.min(1, shell.scrollTop / limit));
        const eased = 1 - Math.pow(1 - progress, 2);
        const inset = Math.round(12 * (1 - eased));
        const radius = Math.round(18 * (1 - eased));
        shell.style.setProperty('--modal-scroll-progress', progress.toFixed(3));
        shell.style.setProperty('--modal-media-inset', `${inset}px`);
        shell.style.setProperty('--modal-media-top', `${inset}px`);
        shell.style.setProperty('--modal-media-radius', `${radius}px`);
        if (progress >= 0.55) {
          shell.classList.add('is-pinned');
        } else {
          shell.classList.remove('is-pinned');
        }
      };
      shell.addEventListener('scroll', modalScrollHandler, { passive: true });
    }

    function teardownModalPinObserver() {
      if (modalScrollTarget && modalScrollHandler) {
        modalScrollTarget.removeEventListener('scroll', modalScrollHandler);
        modalScrollTarget.style.removeProperty('--modal-scroll-progress');
        modalScrollTarget.style.removeProperty('--modal-media-inset');
        modalScrollTarget.style.removeProperty('--modal-media-top');
        modalScrollTarget.style.removeProperty('--modal-media-radius');
        modalScrollTarget.classList.remove('is-pinned');
      }
      modalScrollTarget = null;
      modalScrollHandler = null;
    }

    function tuneInDelay() {
      if (prefersReducedMotion) return 0;
      return mobileLayout.matches ? 350 : 550;
    }

    function clearTuneDismiss() {
      if (tuneDismissTimer) {
        window.clearTimeout(tuneDismissTimer);
        tuneDismissTimer = null;
      }
    }

    function removeModalTune() {
      const tuneEl = modalMedia.querySelector('.video-wall__modal-tune');
      if (tuneEl) tuneEl.remove();
    }

    function nudgeModalPlayback() {
      const video = modalMedia.querySelector('video');
      if (video) {
        video.play().catch(() => {
          video.muted = true;
          video.setAttribute('muted', '');
          video.play().catch(() => {});
        });
      }
      const iframe = modalMedia.querySelector('iframe');
      if (!iframe) return;
      const src = iframe.src || '';
      try {
        if (src.includes('youtube.com') || src.includes('youtu.be')) {
          iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        } else if (src.includes('vimeo.com')) {
          iframe.contentWindow.postMessage('{"method":"play"}', '*');
        }
      } catch (e) { /* ignore */ }
    }

    function finishModalTuneIn() {
      clearTuneDismiss();
      removeModalTune();
      if (currentTile) nudgeModalPlayback();
    }

    function scheduleModalTuneIn() {
      clearTuneDismiss();
      const tune = document.createElement('div');
      tune.className = 'video-wall__modal-tune';
      tune.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0511/4393/4148/files/bww-tv-white.png?v=1779463106" alt="" width="800" height="240">';
      modalMedia.appendChild(tune);

      const delay = tuneInDelay();
      if (delay === 0) {
        finishModalTuneIn();
        return;
      }

      let finished = false;
      const finishOnce = () => {
        if (finished) return;
        finished = true;
        finishModalTuneIn();
      };

      tuneDismissTimer = window.setTimeout(finishOnce, delay);

      const video = modalMedia.querySelector('video');
      if (video) {
        video.addEventListener('playing', finishOnce, { once: true });
        video.addEventListener('canplay', finishOnce, { once: true });
      }
      const iframe = modalMedia.querySelector('iframe');
      if (iframe) {
        iframe.addEventListener('load', () => window.setTimeout(finishOnce, 100), { once: true });
      }
    }

    function renderModalMedia(tile, options = {}) {
      clearTuneDismiss();
      removeModalTune();
      clearModalStage();
      mountModalMedia(tile, options);
      scheduleModalTuneIn();
      bindBugOnPlayback();
    }

    function getModalVideo() {
      return modalMedia ? modalMedia.querySelector('video') : null;
    }

    function syncSoundButton() {
      if (!soundButton) return;
      const video = getModalVideo();
      const show = mobileLayout.matches && !!video;
      soundButton.hidden = !show;
      if (!video) return;
      const on = !video.muted;
      soundButton.setAttribute('aria-pressed', on ? 'true' : 'false');
      soundButton.setAttribute('aria-label', on ? 'Mute' : 'Unmute');
    }

    function mountModalMedia(tile, options = {}) {
      const mount = mediaMountTarget();
      if (!mount) return;
      const tryUnmuted = !!options.unmuted;
      const fileSrc = modalVideoSrc(tile);
      if (fileSrc) {
        const video = document.createElement('video');
        video.controls = !mobileLayout.matches;
        video.autoplay = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.setAttribute('autoplay', '');
        video.preload = 'auto';
        video.setAttribute('aria-label', tile.title);
        if (tile.poster.url) video.poster = tile.poster.url;
        video.src = fileSrc;
        video.muted = !tryUnmuted;
        if (tryUnmuted) video.removeAttribute('muted');
        else video.setAttribute('muted', '');
        video.addEventListener('error', () => renderExternalFallback(tile), { once: true });
        if (bugEl && bugEl.parentElement === mount) {
          mount.insertBefore(video, bugEl);
        } else {
          mount.appendChild(video);
        }
        video.load();
        video.play().catch(() => {
          if (tryUnmuted) return;
          video.muted = true;
          video.setAttribute('muted', '');
          video.play().catch(() => {});
        });
        syncSoundButton();
        return;
      }

      if (soundButton) soundButton.hidden = true;

      const embed = buildEmbedUrl(tile, { unmuted: tryUnmuted });
      if (embed) {
        const iframe = document.createElement('iframe');
        iframe.src = embed;
        iframe.title = tile.title;
        iframe.loading = 'eager';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.allowFullscreen = true;
        iframe.addEventListener('error', () => renderExternalFallback(tile), { once: true });
        iframe.addEventListener('load', positionBugOverVideo);
        if (bugEl && bugEl.parentElement === mount) {
          mount.insertBefore(iframe, bugEl);
        } else {
          mount.appendChild(iframe);
        }
        return;
      }

      if (tile.videoUrl) {
        renderExternalFallback(tile);
        return;
      }

      renderStaticFallback(tile);
    }

    function renderExternalFallback(tile) {
      const mount = mediaMountTarget();
      if (!mount) return;
      Array.from(mount.children).forEach((node) => {
        if (node !== bugEl) node.remove();
      });
      const fallback = tile.heroImage.url || tile.poster.url || tile.squareImage.url || getVideoThumbnail(tile);
      const panel = document.createElement('div');
      panel.className = 'video-wall__external';
      if (fallback) {
        const img = document.createElement('img');
        img.src = fallback;
        img.alt = tile.heroImage.alt || tile.poster.alt || tile.squareImage.alt || '';
        panel.appendChild(img);
      }

      const label = document.createElement('div');
      label.className = 'video-wall__external-copy';
      label.innerHTML = `<strong>Watch externally</strong><span>Open this video on its original platform.</span>`;
      panel.appendChild(label);

      if (tile.videoUrl) {
        const link = document.createElement('a');
        link.className = 'video-wall__external-link';
        link.href = tile.videoUrl;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = externalLinkLabel(tile);
        panel.appendChild(link);
      }
      mount.appendChild(panel);
      window.requestAnimationFrame(positionBugOverVideo);
    }

    function renderStaticFallback(tile) {
      const mount = mediaMountTarget();
      if (!mount) return;
      Array.from(mount.children).forEach((node) => {
        if (node !== bugEl) node.remove();
      });
      const fallback = tile.heroImage.url || tile.poster.url || tile.squareImage.url || getVideoThumbnail(tile);
      if (!fallback) return;
      const img = document.createElement('img');
      img.src = fallback;
      img.alt = tile.heroImage.alt || tile.poster.alt || tile.squareImage.alt || '';
      mount.appendChild(img);
    }

    function renderCreator(tile) {
      const creator = root.querySelector('[data-video-wall-creator]');
      creator.textContent = '';
      if (!tile.creator.name && !tile.creator.handle) {
        creator.hidden = true;
        return;
      }
      creator.hidden = false;

      const imageUrl = tile.creator.avatarUrl || tile.creator.logoUrl;
      if (imageUrl) {
        const img = document.createElement('img');
        img.src = imageUrl;
        img.alt = tile.creator.avatarAlt || tile.creator.logoAlt || '';
        img.loading = 'lazy';
        creator.appendChild(img);
      }

      const text = document.createElement(tile.creator.url ? 'a' : 'div');
      if (tile.creator.url) {
        text.href = tile.creator.url;
        text.target = '_blank';
        text.rel = 'noopener noreferrer';
      }
      text.innerHTML = `${escapeHtml(tile.creator.name || 'Creator')}${tile.creator.handle ? `<span>${escapeHtml(tile.creator.handle)}</span>` : ''}`;
      creator.appendChild(text);
    }

    function renderChips(tile) {
      const chips = root.querySelector('[data-video-wall-chips]');
      chips.textContent = '';
      const refs = [
        ['Brand', tile.refs.brand],
        ['Venue', tile.refs.venue],
        ['Event', tile.refs.event],
        ['Sponsor', tile.refs.sponsor]
      ];

      refs.forEach(([label, ref]) => {
        if (!ref || !ref.name) return;
        const chip = document.createElement(ref.url ? 'a' : 'span');
        chip.className = 'video-wall__ref-chip';
        chip.textContent = `${label}: ${ref.name}`;
        if (ref.url) chip.href = ref.url;
        chips.appendChild(chip);
      });
    }

    function renderCta(tile) {
      const cta = root.querySelector('[data-video-wall-cta]');
      if (!cta) return;
      if (tile.ctaLabel && tile.ctaUrl) {
        cta.hidden = false;
        cta.textContent = tile.ctaLabel;
        cta.href = tile.ctaUrl;
      } else {
        cta.hidden = true;
        cta.removeAttribute('href');
      }
    }

    function renderTranscript(tile) {
      const wrap = root.querySelector('[data-video-wall-transcript-wrap]');
      const body = root.querySelector('[data-video-wall-transcript]');
      if (tile.transcript) {
        wrap.hidden = false;
        body.textContent = tile.transcript;
      } else {
        wrap.hidden = true;
        body.textContent = '';
      }
    }

    function renderNext(tile) {
      const wrap = root.querySelector('[data-video-wall-next-wrap]');
      const rail = root.querySelector('[data-video-wall-next]');
      rail.textContent = '';

      const relatedIds = tile.relatedTiles.map((related) => related.id || related.handle).filter(Boolean);
      let next = relatedIds
        .map((id) => tiles.find((candidate) => candidate.id === id || candidate.handle === id))
        .filter(Boolean);

      if (!next.length) {
        next = tiles
          .filter((candidate) => candidate.id !== tile.id)
          .filter((candidate) => (
            (tile.eventType && candidate.eventType === tile.eventType) ||
            (tile.year && candidate.year === tile.year) ||
            (tile.refs.brand.name && candidate.refs.brand.name === tile.refs.brand.name)
          ))
          .slice(0, 4);
      }

      next = next.filter((candidate) => candidate.poster.url || candidate.squareImage.url || candidate.heroImage.url || getVideoThumbnail(candidate));
      wrap.hidden = !next.length;
      next.slice(0, 3).forEach((candidate) => {
        const card = document.createElement('button');
        card.type = 'button';
        card.className = 'video-wall__next-card';
        const image = candidate.poster.url || candidate.squareImage.url || candidate.heroImage.url || getVideoThumbnail(candidate);
        card.innerHTML = `<img src="${escapeAttr(image)}" alt="${escapeAttr(candidate.poster.alt || candidate.title)}" loading="lazy"><span>${escapeHtml(candidate.title)}</span>`;
        card.addEventListener('click', () => openModal(candidate, lastFocused));
        rail.appendChild(card);
      });
    }

    function updateFilterButtons() {
      if (!filterGroups) return;
      filterGroups.querySelectorAll('[data-filter-key]').forEach((button) => {
        const key = button.dataset.filterKey;
        button.classList.toggle('is-active', (state[key] || '') === button.dataset.filterValue);
      });
    }

    function updateStatus() {
      if (!status) return;
      const shown = Math.min(renderedCount, visibleTiles.length);
      status.textContent = visibleTiles.length
        ? `Showing ${shown} of ${visibleTiles.length} videos`
        : 'No videos to show';
    }

    function matchesState(tile) {
      if (state.wall && !tile.wall.includes(state.wall)) return false;
      if (state.year && tile.year !== state.year) return false;
      if (state.type && tile.eventType !== state.type) return false;
      if (!state.q) return true;
      const haystack = [
        tile.title,
        tile.subtitle,
        tile.summary,
        tile.creator.name,
        tile.creator.handle,
        tile.eventType,
        tile.year,
        tile.locationName,
        tile.tags.join(' '),
        tile.people.join(' ')
      ].filter(Boolean).join(' ').toLowerCase();
      return haystack.includes(state.q.toLowerCase());
    }

    function getState(fallbackWall) {
      const params = new URLSearchParams(window.location.search);
      return {
        wall: params.get('wall') || fallbackWall,
        year: params.get('year') || '',
        type: params.get('type') || '',
        q: params.get('q') || ''
      };
    }

    function updateUrl() {
      const params = new URLSearchParams(window.location.search);
      ['wall', 'year', 'type', 'q'].forEach((key) => {
        if (state[key]) params.set(key, state[key]);
        else params.delete(key);
      });
      if (activeVideoHandle) params.set('v', activeVideoHandle);
      else params.delete('v');
      const query = params.toString();
      const url = `${window.location.pathname}${query ? `?${query}` : ''}`;
      window.history.replaceState({}, '', url);
    }

    // Build an absolute, shareable link to a specific video tile, preserving any active filters.
    function shareUrlFor(tile) {
      if (isHighlights && modal) {
        const watchUrl = modal.getAttribute('data-watch-url') || '/pages/watch';
        const base = watchUrl.indexOf('http') === 0 ? watchUrl : `${window.location.origin}${watchUrl}`;
        const separator = base.indexOf('?') === -1 ? '?' : '&';
        return `${base}${separator}v=${encodeURIComponent(tile.handle || tile.id || '')}`;
      }
      const params = new URLSearchParams(window.location.search);
      ['wall', 'year', 'type', 'q'].forEach((key) => {
        if (state[key]) params.set(key, state[key]);
        else params.delete(key);
      });
      params.set('v', tile.handle || tile.id);
      return `${window.location.origin}${window.location.pathname}?${params.toString()}`;
    }

    function resetShareLabel() {
      window.clearTimeout(shareResetTimer);
      if (shareLabel) shareLabel.textContent = 'Share';
      if (shareButton) shareButton.classList.remove('is-copied');
    }

    async function handleShare() {
      if (!currentTile) return;
      const url = shareUrlFor(currentTile);
      const shareData = { title: currentTile.title || 'Belfast Whiskey Week', url };
      // Prefer the native share sheet on devices that support it (mobile); fall back to clipboard.
      if (navigator.share && (mobileLayout.matches || !navigator.clipboard)) {
        try {
          await navigator.share(shareData);
          return;
        } catch (error) {
          if (error && error.name === 'AbortError') return;
        }
      }
      try {
        await navigator.clipboard.writeText(url);
      } catch (error) {
        // Last-ditch fallback for browsers without the async clipboard API.
        const temp = document.createElement('textarea');
        temp.value = url;
        temp.setAttribute('readonly', '');
        temp.style.position = 'absolute';
        temp.style.left = '-9999px';
        document.body.appendChild(temp);
        temp.select();
        try { document.execCommand('copy'); } catch (e) { /* ignore */ }
        document.body.removeChild(temp);
      }
      if (shareLabel) shareLabel.textContent = 'Link copied';
      if (shareButton) shareButton.classList.add('is-copied');
      window.clearTimeout(shareResetTimer);
      shareResetTimer = window.setTimeout(resetShareLabel, 2200);
    }

    // Open the video referenced by a ?v=<handle> deep link, if present and matching a tile.
    function openFromDeepLink() {
      const params = new URLSearchParams(window.location.search);
      const handle = params.get('v');
      if (!handle) return;
      const tile = tiles.find((candidate) => candidate.handle === handle || candidate.id === handle);
      if (tile) openModal(tile);
    }

    function createVideoObserver() {
      if (prefersReducedMotion || !('IntersectionObserver' in window)) return null;

      return new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.muted = true;
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }, { rootMargin: '120px 0px', threshold: 0.2 });
    }

    function createLoadObserver() {
      if (!('IntersectionObserver' in window)) return null;
      return new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || renderedCount >= visibleTiles.length) return;
          renderMore();
          updateStatus();
        });
      }, { rootMargin: '800px 0px' });
    }
  }

  function normalizeTile(tile) {
    if (!tile || !tile.title) return null;
    const poster = tile.poster && tile.poster.url
      ? tile.poster
      : { url: tile.posterUrl || '', alt: tile.posterAlt || tile.title || '' };
    const heroImage = tile.heroImage && tile.heroImage.url
      ? tile.heroImage
      : { url: tile.heroUrl || '', alt: tile.posterAlt || tile.title || '' };
    const squareImage = tile.squareImage && tile.squareImage.url
      ? tile.squareImage
      : { url: tile.squareImageUrl || '', alt: tile.posterAlt || '' };
    return {
      ...tile,
      id: String(tile.id || tile.handle || tile.title),
      handle: String(tile.handle || ''),
      wall: toArray(tile.wall),
      tags: toArray(tile.tags),
      people: toArray(tile.people),
      relatedTiles: toArray(tile.relatedTiles),
      featured: Boolean(tile.featured),
      priority: Number(tile.priority || 0),
      publishedTime: tile.publishedDate ? Date.parse(tile.publishedDate) || 0 : 0,
      aspectRatio: ['1:1', '9:16', '16:9', '2:3'].includes(tile.aspectRatio) ? tile.aspectRatio : '16:9',
      accentColor: tile.accentColor || '#C8A96E',
      poster,
      heroImage,
      squareImage,
      creator: tile.creator || {},
      refs: tile.refs || { brand: {}, venue: {}, event: {}, sponsor: {} },
      extra: parseExtra(tile.extraData)
    };
  }

  function sortTiles(a, b) {
    if (a.featured !== b.featured) return a.featured ? -1 : 1;
    if (a.priority !== b.priority) return b.priority - a.priority;
    return b.publishedTime - a.publishedTime;
  }

  function uniqueValues(tiles, key) {
    const values = new Set();
    tiles.forEach((tile) => {
      const value = tile[key];
      if (Array.isArray(value)) value.forEach((item) => item && values.add(String(item)));
      else if (value) values.add(String(value));
    });
    return Array.from(values).sort((a, b) => b.localeCompare(a, undefined, { numeric: true }));
  }

  function formatFilterLabel(value, key) {
    const labels = {
      wall: {
        archive: 'Archive',
        homepage: 'Homepage',
        brands: 'Brands',
        venues: 'Venues'
      },
      type: {
        podcast: 'Podcasts',
        partner_channel: 'Partner channels',
        partner_brand: 'Partner brands',
        official_channel: 'Official films',
        music_session: 'Music sessions',
        launch: 'Launch films',
        coverage: 'Coverage'
      }
    };

    if (labels[key] && labels[key][value]) return labels[key][value];
    return String(value || '')
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\b\w/g, (letter) => letter.toUpperCase());
  }

  function isDirectVideoFile(url) {
    return typeof url === 'string' && /\.(mp4|webm|ogv|ogg|mov|m4v)(\?|#|$)/i.test(url);
  }

  function videoMimeFromUrl(url) {
    const match = String(url || '').match(/\.(mp4|webm|ogv|ogg|mov|m4v)(\?|#|$)/i);
    const ext = match ? match[1].toLowerCase() : 'mp4';
    if (ext === 'webm') return 'video/webm';
    if (ext === 'ogv' || ext === 'ogg') return 'video/ogg';
    return 'video/mp4';
  }

  // Pick a directly-playable progressive file for the modal player. HLS (.m3u8)
  // URLs are skipped because Chrome/Firefox can't play them natively, which is
  // what produced "No video with supported format and MIME type found".
  function modalVideoSrc(tile) {
    const candidates = [tile.expandedVideoUrl, tile.videoUrl, tile.loopVideoUrl];
    for (let i = 0; i < candidates.length; i += 1) {
      if (isDirectVideoFile(candidates[i])) return candidates[i];
    }
    return '';
  }

  function youtubeEmbedQuery(unmuted) {
    const origin = typeof window !== 'undefined' && window.location && window.location.origin
      ? `&origin=${encodeURIComponent(window.location.origin)}`
      : '';
    const mute = unmuted ? 0 : 1;
    return `autoplay=1&mute=${mute}&playsinline=1&rel=0&modestbranding=1&iv_load_policy=3&enablejsapi=1${origin}`;
  }

  function buildEmbedUrl(tile, options = {}) {
    const source = String(tile.videoSource || '').toLowerCase();
    const id = tile.videoId || extractVideoId(tile.videoUrl, source);
    const unmuted = !!options.unmuted;
    if (source === 'youtube' && id) {
      return `https://www.youtube.com/embed/${encodeURIComponent(id)}?${youtubeEmbedQuery(unmuted)}`;
    }
    if (source === 'vimeo' && id) {
      const muted = unmuted ? 0 : 1;
      return `https://player.vimeo.com/video/${encodeURIComponent(id)}?autoplay=1&muted=${muted}&playsinline=1`;
    }
    return '';
  }

  function externalLinkLabel(tile) {
    const source = String(tile.videoSource || '').toLowerCase();
    if (source === 'youtube') return 'Open on YouTube';
    if (source === 'vimeo') return 'Open on Vimeo';
    return 'Open video';
  }

  function getVideoThumbnail(tile, quality) {
    const source = String(tile.videoSource || '').toLowerCase();
    const id = tile.videoId || extractVideoId(tile.videoUrl, source);
    const thumbQuality = quality || 'hqdefault';
    if (source === 'youtube' && id) return `https://i.ytimg.com/vi/${encodeURIComponent(id)}/${thumbQuality}.jpg`;
    return '';
  }

  function bindYouTubeThumbnailFallback(img, tile, tileEl) {
    const fallbacks = ['sddefault', 'hqdefault', 'mqdefault'];
    let index = 0;

    function tryNext() {
      const next = getVideoThumbnail(tile, fallbacks[index]);
      index += 1;
      if (next && img.src !== next) img.src = next;
    }

    img.addEventListener('error', tryNext);
    img.addEventListener('load', () => {
      const isTinyPlaceholder = img.naturalWidth > 0 && img.naturalWidth < 300;
      if (isTinyPlaceholder && index < fallbacks.length) tryNext();
      else if (looksLikePlaceholderThumbnail(img)) tileEl.hidden = true;
    });
  }

  function looksLikePlaceholderThumbnail(img) {
    try {
      const canvas = document.createElement('canvas');
      const width = 24;
      const height = 24;
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      if (!ctx) return false;
      ctx.drawImage(img, 0, 0, width, height);
      const data = ctx.getImageData(0, 0, width, height).data;
      let lowSaturation = 0;
      let midGrey = 0;
      const total = width * height;
      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        const avg = (r + g + b) / 3;
        if (max - min < 18) lowSaturation += 1;
        if (avg > 95 && avg < 220) midGrey += 1;
      }
      return lowSaturation / total > 0.86 && midGrey / total > 0.74;
    } catch (error) {
      return false;
    }
  }

  function extractVideoId(url, source) {
    if (!url) return '';
    try {
      const parsed = new URL(url);
      if (source === 'youtube') {
        if (parsed.hostname.includes('youtu.be')) return parsed.pathname.replace('/', '');
        return parsed.searchParams.get('v') || parsed.pathname.split('/').filter(Boolean).pop() || '';
      }
      if (source === 'vimeo') return parsed.pathname.split('/').filter(Boolean).pop() || '';
    } catch (error) {
      return '';
    }
    return '';
  }

  function toArray(value) {
    if (!value) return [];
    if (Array.isArray(value)) return value.filter(Boolean).map((item) => {
      if (typeof item === 'object') return item.title || item.name || item.handle || item.id || '';
      return String(item);
    }).filter(Boolean);
    return [String(value)];
  }

  function parseExtra(value) {
    if (!value) return {};
    if (typeof value === 'object') return value;
    return safeJson(value, {});
  }

  function safeJson(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function firstAccent(tiles) {
    const tile = tiles.find((candidate) => candidate.accentColor);
    return tile ? tile.accentColor : '#C8A96E';
  }

  function debounce(callback, wait) {
    let id;
    return function (...args) {
      window.clearTimeout(id);
      id = window.setTimeout(() => callback.apply(this, args), wait);
    };
  }

  function trapFocus(event) {
    if (event.key !== 'Tab') return;
    const focusable = Array.from(event.currentTarget.querySelectorAll('a[href], button:not([disabled]), video[controls], iframe, [tabindex]:not([tabindex="-1"])'));
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    })[char]);
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/`/g, '&#096;');
  }

  function formatDuration(seconds) {
    const total = Number(seconds);
    if (!Number.isFinite(total) || total <= 0) return '';
    const hrs = Math.floor(total / 3600);
    const mins = Math.floor((total % 3600) / 60);
    const secs = Math.floor(total % 60);
    if (hrs > 0) return `${hrs}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    return `${mins}:${String(secs).padStart(2, '0')}`;
  }
})();
